module.exports = __webpack_public_path__ + "img/garage-arbor.9c8d87cb.webp";